import { render, staticRenderFns } from "./LectureLessonPDFDocument.vue?vue&type=template&id=e77b6410&"
import script from "./LectureLessonPDFDocument.vue?vue&type=script&lang=js&"
export * from "./LectureLessonPDFDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports